import React from 'react';
import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
import { useServicesContext } from '../../../../context';
import { useFormattedPrice } from '../../../../hooks';
import { SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_LG } from '@oneaudi/unified-web-common';
import { dynamicStylingHelper } from '../../../utils';
const ParameterItem = styled.div `
  margin-bottom: ${(props) => props.isLast ? '0' : dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_LG)};
`;
export const FinanceLayerParameter = ({ parameter, isLast, }) => {
    const { audiMarketContextService, getConfiguration } = useServicesContext();
    const currency = getConfiguration().currency ||
        (audiMarketContextService === null || audiMarketContextService === void 0 ? void 0 : audiMarketContextService.getContextItem('nemo.locale.currency'));
    const isCurrency = parameter.unit === currency || parameter.unitSymbol === currency;
    let unitSymbol = '';
    if (parameter === null || parameter === void 0 ? void 0 : parameter.unitSymbol) {
        unitSymbol = parameter === null || parameter === void 0 ? void 0 : parameter.unitSymbol;
    }
    else if (parameter === null || parameter === void 0 ? void 0 : parameter.unit) {
        unitSymbol = parameter.unit;
    }
    const formattedValue = isCurrency
        ? useFormattedPrice(parameter.formattedValue || '', parameter.unitSymbol || '', parameter.unit || '')
        : `${parameter.formattedValue || ''} ${unitSymbol}`;
    return (React.createElement(ParameterItem, { isLast: isLast },
        React.createElement(Text, { tag: "p", variant: {
                order: dynamicStylingHelper('2', '3'),
                style: 'bold',
                type: 'copy',
            } },
            parameter.label,
            " ",
            !!parameter.note && React.createElement(React.Fragment, null, parameter.note)),
        React.createElement(Text, { tag: "p", variant: {
                order: '1',
                style: 'normal',
                type: 'copy',
            } }, formattedValue)));
};
